import { i as copy_payload, j as assign_payload, p as pop, a as push, h as head, k as ensure_array_like, e as escape_html, b as attr, c as attr_class, n as maybe_selected, m as stringify } from "../../../../chunks/index2.js";
import "@sveltejs/kit/internal";
import "../../../../chunks/exports.js";
import "../../../../chunks/utils.js";
import "../../../../chunks/state.svelte.js";
import { g as getToastState } from "../../../../chunks/Toast.svelte.js";
import { M as Modal } from "../../../../chunks/Modal.js";
import "../../../../chunks/validationSchemas.js";
function _page($$payload, $$props) {
  push();
  getToastState();
  const { data, form } = $$props;
  const promotions = data.promotions || [];
  const products = data.products || [];
  const categories = data.categories || [];
  const currentPage = data.page || 1;
  const totalPages = data.totalPages || 1;
  let showModal = false;
  let formErrors = {};
  let name = "";
  let description = "";
  let discountType = "PERCENT";
  let discountValue = "";
  let code = "";
  let startsAt = "";
  let endsAt = "";
  let isActive = true;
  let priority = 100;
  let selectedProducts = [];
  let selectedCategories = [];
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    head($$payload2, ($$payload3) => {
      $$payload3.title = `<title>Promotions | Admin</title>`;
    });
    $$payload2.out.push(`<div class="container mx-auto space-y-6 p-6"><div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"><h1 class="text-3xl font-bold">Promotions</h1> <button class="bg-primary hover:bg-primary/90 cursor-pointer rounded-lg px-4 py-2 text-white">New Promotion</button></div> <div class="overflow-x-auto rounded-md border bg-white"><table class="min-w-full divide-y divide-gray-200 text-sm"><thead class="bg-gray-50"><tr><th class="px-4 py-2 text-left font-medium text-gray-600">Name</th><th class="px-4 py-2 text-left font-medium text-gray-600">Discount</th><th class="px-4 py-2 text-left font-medium text-gray-600">Active Window</th><th class="px-4 py-2 text-left font-medium text-gray-600">Scope</th><th class="px-4 py-2 text-left font-medium text-gray-600">Status</th><th class="px-4 py-2 text-left font-medium text-gray-600">Actions</th></tr></thead><tbody class="divide-y divide-gray-100">`);
    if (promotions.length === 0) {
      $$payload2.out.push("<!--[-->");
      $$payload2.out.push(`<tr><td colspan="6" class="px-4 py-6 text-center text-gray-500">No promotions found</td></tr>`);
    } else {
      $$payload2.out.push("<!--[!-->");
      const each_array = ensure_array_like(promotions);
      $$payload2.out.push(`<!--[-->`);
      for (let $$index_2 = 0, $$length = each_array.length; $$index_2 < $$length; $$index_2++) {
        let promo = each_array[$$index_2];
        const each_array_1 = ensure_array_like(promo.products);
        const each_array_2 = ensure_array_like(promo.categories);
        $$payload2.out.push(`<tr class="hover:bg-gray-50"><td class="px-4 py-2 font-medium">${escape_html(promo.name)}</td><td class="px-4 py-2">${escape_html(promo.discountType === "PERCENT" ? `${promo.discountValue}%` : `KES ${promo.discountValue}`)}</td><td class="px-4 py-2 whitespace-nowrap">${escape_html(new Date(promo.startsAt).toLocaleDateString("en-KE", { day: "2-digit", month: "short", year: "numeric" }))} – ${escape_html(new Date(promo.endsAt).toLocaleDateString("en-KE", { day: "2-digit", month: "short", year: "numeric" }))}</td><td class="max-w-xs px-4 py-2"><div class="flex flex-wrap gap-1"><!--[-->`);
        for (let $$index = 0, $$length2 = each_array_1.length; $$index < $$length2; $$index++) {
          let p = each_array_1[$$index];
          $$payload2.out.push(`<span class="rounded bg-blue-50 px-2 py-0.5 text-xs text-blue-700">P:${escape_html(p.product.name)}</span>`);
        }
        $$payload2.out.push(`<!--]--> <!--[-->`);
        for (let $$index_1 = 0, $$length2 = each_array_2.length; $$index_1 < $$length2; $$index_1++) {
          let c = each_array_2[$$index_1];
          $$payload2.out.push(`<span class="rounded bg-purple-50 px-2 py-0.5 text-xs text-purple-700">C:${escape_html(c.category.name)}</span>`);
        }
        $$payload2.out.push(`<!--]--></div></td><td class="px-4 py-2">`);
        if (promo.isActive) {
          $$payload2.out.push("<!--[-->");
          $$payload2.out.push(`<span class="rounded-full bg-green-100 px-2 py-0.5 text-xs text-green-700">Active</span>`);
        } else {
          $$payload2.out.push("<!--[!-->");
          $$payload2.out.push(`<span class="rounded-full bg-gray-200 px-2 py-0.5 text-xs text-gray-700">Inactive</span>`);
        }
        $$payload2.out.push(`<!--]--></td><td class="space-x-3 px-4 py-2"><form method="POST" action="?/toggle_active" class="inline"><input type="hidden" name="id"${attr("value", promo.id)}/> <button type="submit" class="text-primary text-xs hover:underline">Toggle</button></form> <form method="POST" action="?/delete" class="inline"><input type="hidden" name="id"${attr("value", promo.id)}/> <button type="submit" class="text-xs text-red-600 hover:underline">Delete</button></form></td></tr>`);
      }
      $$payload2.out.push(`<!--]-->`);
    }
    $$payload2.out.push(`<!--]--></tbody></table></div> `);
    if (totalPages > 1) {
      $$payload2.out.push("<!--[-->");
      const each_array_3 = ensure_array_like(Array(totalPages));
      $$payload2.out.push(`<div class="flex justify-center gap-2"><!--[-->`);
      for (let i = 0, $$length = each_array_3.length; i < $$length; i++) {
        each_array_3[i];
        $$payload2.out.push(`<a${attr("href", `?page=${i + 1}`)}><button${attr_class(`cursor-pointer rounded px-3 py-1 text-sm ${stringify(currentPage === i + 1 ? "bg-primary text-white" : "bg-gray-100")}`)}>${escape_html(i + 1)}</button></a>`);
      }
      $$payload2.out.push(`<!--]--></div>`);
    } else {
      $$payload2.out.push("<!--[!-->");
    }
    $$payload2.out.push(`<!--]--></div> `);
    Modal($$payload2, {
      title: "Create Promotion",
      modalClass: "max-w-5xl",
      get show() {
        return showModal;
      },
      set show($$value) {
        showModal = $$value;
        $$settled = false;
      },
      children: ($$payload3) => {
        const each_array_4 = ensure_array_like(products);
        const each_array_5 = ensure_array_like(categories);
        $$payload3.out.push(`<form method="POST" action="?/create" class="space-y-4">`);
        if (formErrors._errors) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<div class="rounded bg-red-50 p-2 text-sm text-red-600">${escape_html(formErrors._errors[0])}</div>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--> <div class="grid gap-4 sm:grid-cols-2"><div class="space-y-1"><label for="promo_name" class="text-sm font-medium">Name</label> <input id="promo_name" name="name"${attr("value", name)} class="focus:ring-primary w-full rounded border px-2 py-1 focus:ring-1" required/> `);
        if (formErrors.name) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p class="text-xs text-red-600">${escape_html(formErrors.name[0])}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--></div> <div class="space-y-1"><label for="promo_code" class="text-sm font-medium">Code <span class="text-xs text-gray-500">(optional)</span></label> <input id="promo_code" name="code"${attr("value", code)} class="focus:ring-primary w-full rounded border px-2 py-1 focus:ring-1"/> `);
        if (formErrors.code) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p class="text-xs text-red-600">${escape_html(formErrors.code[0])}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--></div> <div class="space-y-1"><label for="promo_discount_type" class="text-sm font-medium">Discount Type</label> <select id="promo_discount_type" name="discountType" class="w-full rounded border px-2 py-1">`);
        $$payload3.select_value = discountType;
        $$payload3.out.push(`<option value="PERCENT"${maybe_selected($$payload3, "PERCENT")}>Percent (%)</option><option value="AMOUNT"${maybe_selected($$payload3, "AMOUNT")}>Amount (KES)</option>`);
        $$payload3.select_value = void 0;
        $$payload3.out.push(`</select></div> <div class="space-y-1"><label for="promo_discount_value" class="text-sm font-medium">Discount Value</label> <input id="promo_discount_value" name="discountValue" type="number" min="0" step="0.01"${attr("value", discountValue)} class="focus:ring-primary w-full rounded border px-2 py-1 focus:ring-1" required/> `);
        if (formErrors.discountValue) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p class="text-xs text-red-600">${escape_html(formErrors.discountValue[0])}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--></div> <div class="space-y-1"><label for="promo_starts" class="text-sm font-medium">Starts At</label> <input id="promo_starts" name="startsAt" type="date"${attr("value", startsAt)} class="w-full rounded border px-2 py-1" required/></div> <div class="space-y-1"><label for="promo_ends" class="text-sm font-medium">Ends At</label> <input id="promo_ends" name="endsAt" type="date"${attr("value", endsAt)} class="w-full rounded border px-2 py-1" required/> `);
        if (formErrors.endsAt) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p class="text-xs text-red-600">${escape_html(formErrors.endsAt[0])}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--></div> <div class="space-y-1"><label for="promo_priority" class="text-sm font-medium">Priority</label> <input id="promo_priority" name="priority" type="number" min="0"${attr("value", priority)} class="w-full rounded border px-2 py-1"/></div> <div class="flex items-center space-x-2 pt-6"><input id="isActive" name="isActive" type="checkbox"${attr("checked", isActive, true)}/> <label for="isActive" class="text-sm">Active</label></div></div> <div class="space-y-2"><label for="promo_description" class="text-sm font-medium">Description</label> <textarea id="promo_description" name="description" rows="3" class="focus:ring-primary w-full rounded border px-2 py-1 focus:ring-1">`);
        const $$body = escape_html(description);
        if ($$body) {
          $$payload3.out.push(`${$$body}`);
        }
        $$payload3.out.push(`</textarea> `);
        if (formErrors.description) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p class="text-xs text-red-600">${escape_html(formErrors.description[0])}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--></div> <div class="grid gap-6 sm:grid-cols-2"><div><h3 class="mb-1 text-sm font-semibold">Apply to Products</h3> <div class="h-48 space-y-1 overflow-y-auto rounded border p-2 text-xs"><!--[-->`);
        for (let $$index_4 = 0, $$length = each_array_4.length; $$index_4 < $$length; $$index_4++) {
          let p = each_array_4[$$index_4];
          $$payload3.out.push(`<label class="flex items-center gap-2"><input type="checkbox"${attr("checked", selectedProducts.includes(p.id), true)}/> <span>${escape_html(p.name)}</span></label>`);
        }
        $$payload3.out.push(`<!--]--></div></div> <div><h3 class="mb-1 text-sm font-semibold">Apply to Categories</h3> <div class="h-48 space-y-1 overflow-y-auto rounded border p-2 text-xs"><!--[-->`);
        for (let $$index_5 = 0, $$length = each_array_5.length; $$index_5 < $$length; $$index_5++) {
          let c = each_array_5[$$index_5];
          $$payload3.out.push(`<label class="flex items-center gap-2"><input type="checkbox"${attr("checked", selectedCategories.includes(c.id), true)}/> <span>${escape_html(c.name)}</span></label>`);
        }
        $$payload3.out.push(`<!--]--></div></div></div> `);
        if (formErrors.productIds) {
          $$payload3.out.push("<!--[-->");
          $$payload3.out.push(`<p class="text-xs text-red-600">${escape_html(formErrors.productIds[0])}</p>`);
        } else {
          $$payload3.out.push("<!--[!-->");
        }
        $$payload3.out.push(`<!--]--> <button type="submit" class="bg-primary hover:bg-primary/90 w-full cursor-pointer rounded px-4 py-2 text-white">Create Promotion</button></form>`);
      },
      $$slots: { default: true }
    });
    $$payload2.out.push(`<!---->`);
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  pop();
}
export {
  _page as default
};
